import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import dayjs from "dayjs";
import {
  deletePostUsingPost,
  listPostByPageUsingPost,
} from "@/api/postController";
import router from "@/router";
//初始值

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminPostPage',
  setup(__props) {

const initParams = {
  current: 1,
  pageSize: 10,
  sortOrder: "ascend",
  sortField: "createTime",
};
//搜索参数
const formParams = ref<API.PostQueryRequest>({
  ...initParams,
});
//传递参数
const searchParams = ref<API.PostQueryRequest>({});
//数据
const dataList = ref<API.Post[]>([]);
//总值
const total = ref<number>(0);
const loading = ref(false);

const imgListVisible = ref(false);

const post = ref<API.Post>({});
const showImgList = (item: any) => {
  post.value = item;
  imgListVisible.value = true;
};
/**
 * 加载数据
 */
const loadData = async () => {
  loading.value = true;
  const response = await listPostByPageUsingPost(searchParams.value);
  if (response.data.code === 0) {
    dataList.value = response.data.data?.records || [];
    total.value = response.data.data?.total || 0;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};
/**
 * 搜索
 */
const search = () => {
  searchParams.value = { ...initParams, ...formParams.value };
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 当分页变化时，改变搜索条件，触发数据加载
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 更新
 */
const doUpdate = (id: number) => {
  router.push(`/post/edit/${id}`);
};

/**
 * 删除
 */
const doDelete = async (id: number) => {
  const res = await deletePostUsingPost({ id });
  if (res.data.code === 0) {
    loadData();
  } else {
    message.error("删除失败，" + res.data.message);
  }
};

const columns = [
  {
    title: "ID",
    dataIndex: "id",
  },
  {
    title: "用户ID",
    dataIndex: "userId",
  },
  {
    title: "标题",
    dataIndex: "title",
  },
  {
    title: "内容",
    dataIndex: "content",
    slotName: "content",
  },
  {
    title: "图片",
    dataIndex: "imgList",
    slotName: "imgList",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    slotName: "createTime",
  },
  {
    title: "更新时间",
    dataIndex: "updateTime",
    slotName: "updateTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
  {
    title: "标签",
    slotName: "tags",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      model: formParams.value,
      layout: "inline",
      style: {"margin":"0 0 10px auto"},
      "label-align": "left",
      "auto-label-width": "",
      onSubmit: search
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "id",
          label: "ID："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formParams.value.id) = $event)),
              placeholder: "请输入ID...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userId",
          label: "用户ID："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.userId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formParams.value.userId) = $event)),
              placeholder: "请输入...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "title",
          label: "标题："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.title,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formParams.value.title) = $event)),
              placeholder: "请输入...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "content",
          label: "内容："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.content,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formParams.value.content) = $event)),
              placeholder: "请输入...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_space, { size: "large" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/post/edit/0'))),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加帖子 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "排序：" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              modelValue: formParams.value.sortOrder,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formParams.value.sortOrder) = $event)),
              type: "button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, { value: "ascend" }, {
                  default: _withCtx(() => [
                    _createTextVNode("正序")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio, { value: "descend" }, {
                  default: _withCtx(() => [
                    _createTextVNode("倒序")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "排序字段：" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              modelValue: formParams.value.sortField,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formParams.value.sortField) = $event)),
              type: "button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, { value: "createTime" }, {
                  default: _withCtx(() => [
                    _createTextVNode("创建时间")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio, { value: "updateTime" }, {
                  default: _withCtx(() => [
                    _createTextVNode("更新时间")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
      showTotal: true,
      pageSize: searchParams.value.pageSize,
      current: searchParams.value.current,
      total: total.value,
    },
      stripe: true,
      bordered: { cell: true },
      loading: loading.value,
      onPageChange: onPageChange
    }, {
      content: _withCtx(({ record }) => [
        _createVNode(_component_a_button, {
          onClick: ($event: any) => (_ctx.$modal.info({ title: '查看问题内容', content: record.content }))
        }, {
          default: _withCtx(() => [
            _createTextVNode("查看内容 ")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      imgList: _withCtx(({ record }) => [
        (record.imgList?.length > 0)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              onClick: ($event: any) => (showImgList(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode("查看图片 ")
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.createTime).format("YYYY-MM-DD")), 1)
      ]),
      updateTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.updateTime).format("YYYY-MM-DD")), 1)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "outline",
              onClick: ($event: any) => (doUpdate(record.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode("修改")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "outline",
              status: "danger",
              onClick: ($event: any) => (doDelete(record.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode("删除 ")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      tags: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tags, (tag, index) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: index,
                color: "green"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination", "loading"]),
    _createVNode(_component_a_modal, {
      visible: imgListVisible.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((imgListVisible).value = $event)),
      mask: false
    }, {
      title: _withCtx(() => [
        _createTextVNode("图片预览")
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(post.value?.imgList, (img, index) => {
              return (_openBlock(), _createBlock(_component_a_list_item, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_image, {
                    src: img,
                    width: "100",
                    height: "100"
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})